module.exports = __webpack_public_path__ + "img/company-qrcode.c1b7796c.png";